<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.625 15H9.375C6.2625 15 3.75 17.5125 3.75 20.625V31.875H11.25V39.375H33.75V31.875H41.25V20.625C41.25 17.5125 38.7375 15 35.625 15ZM30 35.625H15V26.25H30V35.625ZM35.625 22.5C34.5938 22.5 33.75 21.6562 33.75 20.625C33.75 19.5938 34.5938 18.75 35.625 18.75C36.6562 18.75 37.5 19.5938 37.5 20.625C37.5 21.6562 36.6562 22.5 35.625 22.5ZM33.75 5.625H11.25V13.125H33.75V5.625Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPrint',
  props: {
    width: {
      type: Number,
      default: 45,
    },
    height: {
      type: Number,
      default: 45,
    },
  },
};
</script>

<style scoped>
</style>